
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";

  @Component({})
  export default class AlertNotice extends Vue {
    @Prop() barriersList: Barrier.Entity[];

    get displayAlert() { return this.barriersList.some(item => item.theftFlag); }
  }
